export default "__VITE_ASSET__0xwO0vBA__"